import React from 'react';
import Routes from '../../../helpers/Routes';
import Request from '../../../helpers/Request';
import { toast } from 'react-toastify';
import AcceptedSignatureDocRow from './AcceptedSignatureDocRow';
import moment from 'moment';
import qs from 'qs';
import SentDatePickers from '../../Notifications/SentDatePickers';
import SignatureTimeDiff from '../../Statistics/SignatureTimeDiff';
import SentToFilter from '../../Navigation/AdvancedSearchComponents/SentToFilter';
class RecentlySignedDocs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      signedDocs: [],
      sentBefore: moment(),
      sentAfter: moment().subtract(30, 'days'),
      organization: '',
      selectedUser: 'All',
      sentTo: ''
    }
  }
  componentDidMount = () => {
    this.onGetDocuments();
    this.getOrganization();
  }
  getOrganization = () => {
    Request.authRequest(Routes.organization.index, 'GET').then((response) => {
      if (response.status === 200) {
        response.json().then(body => {
          this.setState({ organization: body })

        })
      } else {
        response.json().then((error) => {
          toast.error(error.message);
        });
      }
    }).catch((error) => {
      toast.error(error.message);
    })
  }
  setDate = (date, type) => {
    if (type === 'beforeDate') {
      this.setState({
        sentBefore: date
      }, () => this.onGetDocuments())
    }
    if (type === 'afterDate') {
      this.setState({
        sentAfter: date
      }, () => this.onGetDocuments())
    }
    if (type === 'clearDate') {
      this.setState({
        sentBefore: moment(),
        sentAfter: moment().subtract(30, 'days'),
        selectedUser: 'All'
      }, () => this.onGetDocuments())
    }

  }
  clearInputs = () => {
    this.setState({
      sentBefore: moment(),
      sentAfter: moment().subtract(30, 'days'),
      selectedUser: 'All'
    }, () => this.onGetDocuments())
  }
  onGetDocuments = () => {
    let afterIsoDate = this.state.sentAfter.toISOString();
    let beforeIsoDate = this.state.sentBefore.toISOString();
    let searchString = `?sent_after=${afterIsoDate}&sent_before=${beforeIsoDate}&accepted_docs=true`
    if (this.state.selectedUser !== 'All') {
      searchString += `&email=` + encodeURIComponent(this.state.selectedUser);
    }
    if (this.state.sentTo) {
      searchString += `&sent_to=` + encodeURIComponent(this.state.sentTo);
    }
    Request.authRequest(Routes.reports.recentlySigned(searchString), 'GET').then((response) => {
      if (response.status === 200) {
        response.json().then(body => {
          this.setState({ signedDocs: body })
        })
      } else {
        response.json().then((error) => {

          toast.error(error.message);
        });
      }
    }).catch((error) => {
      toast.error(error.message);
    })
  }
  onSelectUser = (e) => {
    this.setState({
      selectedUser: e.target.value
    }, () => {
      this.onGetDocuments()
    })
  }

  render() {
    let signatureDocs = <div className="helpText">You haven't signed any docs recently. Send some using Ivy!</div>
    if (this.state.signedDocs.length > 0) {
      signatureDocs = this.state.signedDocs.map((signature, i) => {
        return <AcceptedSignatureDocRow signature={signature} key={i} />
      })
    }
    let users;
    if (this.state.organization) {
      users = this.state.organization.members.map((user, i) => {
        return <option value={user.email} key={i}>{user.first_name} {user.last_name} {user.email}</option>
      })
    }

    return (
      <div className="externalDocs-container boxShadow">
        <div className="is-spaced-between">
          <div className="notificationsheader">Recently Signed Docs</div>
          <div onClick={this.clearInputs} className="sentDatePicker-clear">
            Clear Filters</div>
        </div>
        <div >
          <SentDatePickers
            sendDate={this.setDate}
            sentAfter={this.state.sentAfter}
            sentBefore={this.state.sentBefore} signed />
          <div>
            <div className="expirationSearch-label">
              Filter By Signed By</div>
            <select
              value={this.state.selectedUser}
              onChange={this.onSelectUser}
              className="externalDocs-selectUser">
              <option value="All">All users</option>
              {users}
            </select>
          </div>
        </div>
        <SignatureTimeDiff signatures={this.state.signedDocs} />
        <div className="externalDocs-content">{signatureDocs}</div>
      </div>
    )
  }
}

export default RecentlySignedDocs;
